module.exports = "https://www.gc-pro.gnp.com.mx/11917dc1781db916d2b4a4caeb1b4df8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/poliza_activo.svg
// module id = 1857
// module chunks = 0